export default __webpack_public_path__ + "static/media/worldImg.4530d976.png";